"use client";

import React from "react";
import MCMComboboxSupportingDocsOnlyExample from "@/examples/MCMComboboxSupportingDocsOnlyExample";

export default function MCMComboboxSupportingDocsOnlyExamplePage() {
  return (
    <div className="container mx-auto p-6">
      <MCMComboboxSupportingDocsOnlyExample />
    </div>
  );
}
